module.exports = __webpack_public_path__ + "img/gegame.81bd598.webp";